module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE4IDkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTS4wNzQuMDY0bDguNiA4LjU5OUwxNy4yNzMuMDY0eiIgZmlsbD0iI0ZEQkU0NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/form/chevron.svg
// module id = ./src/styles/marketing/form/chevron.svg
// module chunks = 21